module.exports = __webpack_public_path__ + "static/img/img5.89c8af7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img5.png
// module id = 9quO
// module chunks = 1